import { defineMessages } from "react-intl";

export default defineMessages({
  discover: {
    id: "Footer.discover",
    defaultMessage: "Discover",
  },
  becomeServiceProvider: {
    id: "Footer.becomeServiceProvider",
    defaultMessage: "Become a Service Provider",
  },
  requestAService: {
    id: "Footer.requestAService",
    defaultMessage: "Request a Service",
  },
  bestServiceProviders: {
    id: "Footer.bestServiceProviders",
    defaultMessage: "Best Service Providers",
  },
  serviceIdeas: {
    id: "Footer.serviceIdeas",
    defaultMessage: "Service Ideas",
  },
  inviteYourFriends: {
    id: "Footer.inviteYourFriends",
    defaultMessage: "Invite your friends",
  },
  needHelp: {
    id: "Footer.needHelp",
    defaultMessage: "Need help?",
  },
  howDoesItWork: {
    id: "Footer.howDoesItWork",
    defaultMessage: "How does it work?",
  },
  subscriptionPlans: {
    id: "Footer.subscriptionPlans",
    defaultMessage: "Subscription Plans",
  },
  isItLegal: {
    id: "Footer.isItLegal",
    defaultMessage: "Is it legal?",
  },
  contactUs: {
    id: "Footer.contactUs",
    defaultMessage: "Contact Us",
  },
  helpFAQ: {
    id: "Footer.helpFAQ",
    defaultMessage: "Help / FAQ",
  },
  aboutUs: {
    id: "Footer.aboutUs",
    defaultMessage: "About Us",
  },
  theTeam: {
    id: "Footer.theTeam",
    defaultMessage: "The Team",
  },
  company: {
    id: "Footer.company",
    defaultMessage: "Company",
  },
  jobs: {
    id: "Footer.jobs",
    defaultMessage: "Jobs",
  },
  press: {
    id: "Footer.press",
    defaultMessage: "Press",
  },
  blog: {
    id: "Footer.blog",
    defaultMessage: "Blog",
  },
  partners: {
    id: "Footer.partners",
    defaultMessage: "Partners",
  },
  followUs: {
    id: "Footer.followUs",
    defaultMessage: "Follow Us",
  },
  discoverOurMobileApplication: {
    id: "Footer.discoverOurMobileApplication",
    defaultMessage: "Discover our mobile application",
  },
  iNeedAService: {
    id: "Footer.iNeedAService",
    defaultMessage: "I need a service",
  },
  iWantToOfferMyServices: {
    id: "Footer.iWantToOfferMyServices",
    defaultMessage: "I want to offer my services",
  },
  theCompanyIsEvaluatedXOutOfYByZMembers: {
    id: "Footer.theCompanyIsEvaluatedXOutOfYByZMembers",
    defaultMessage: "{companyName} is evaluated {x}/{y} by {z} members",
  },
});
